$(window).on('popstate', function (event) {
  window.history.go(-1);
});
$(document).on("click", ".size-variant-grid .size_radio_block , .size-variant-grid .size_radio_block1", function () {
  $('.product__info-container').find('.price').removeClass('price--on-sale');

  var e = $(this).find("input").attr("data-varid"),
    i = window.location.href,
    s = new URL(i);
  s.searchParams.set("variant", e);
  var a = s.href;
  history.pushState(null, null, a);
}),
  $(document).ready(function () {
    if ($('.wishlist-page').length) {
      $('body').addClass('wishlist-body');
    }
    $(".close-menu svg").click(function () {
      $(this).closest("header-drawer").find(".header__icon--summary").click();
      $('body').removeClass('mobile-menu-toggle');
    }),
      $(document).on("click", "#CartDrawer cart-remove-button", function () {
        setTimeout(function () {
          $(".add-slider-clean").slick({ slidesToShow: 1, slidesToScroll: 1, arrows: !0, dots: !1, infinite: !1, adaptiveHeight: !0 });
        }, 1e3);

      }),
      $(".home-top-banner .Banner_wrapper").slick({ slidesToShow: 1, slidesToScroll: 1, arrows: !0, dots: !0, infinite: !1 }),
      $(".homepage-featured ul.product-grid").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: !0,
        dots: !1,
        infinite: !1,
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: 3 } },
          { breakpoint: 992, settings: { slidesToShow: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1.31 } },
        ],
      }),
      $(document).on("click", ".sizeguide_link", function () {
        $("body").addClass("size_open");
        var e = $(this).attr("class-attr"),
          i = $.trim(e);
        $(".size_popup_content").hide(),
          $(".size_popup_content." + i).show(),
          $(".quick-add-modal").each(function () {
            $(this).attr("open") && ($(this).removeAttr("open"), $(this).addClass("remove-open"));
          });
      }),
      $(document).on("click", ".size_popup_close", function () {
        $("body").removeClass("size_open"), $(".quick-add-modal.remove-open").attr("open", "true");
      }),
      $(document).on("click", ".quick-add-modal__toggle", function () {
        $(".quick-add-modal").each(function () {
          $(this).hasClass("remove-open") && ($(this).removeAttr("open"), $(this).removeClass("remove-open"), $("body").removeClass("overflow-hidden"));
        });
      }),
      $(".product product-info .price").hasClass("price--sold-out") ? ($(".deliver_text").hide(), $(".product .hours-card-badge").hide()) : ($(".deliver_text").show(), $(".product .hours-card-badge").show()),
      0 >= $('.product-form__input .select select option[selected="selected"]').data("qty") ? ($(".deliver_text").hide(), $(".product .hours-card-badge").hide()) : ($(".deliver_text").show(), $(".product .hours-card-badge").show()),
      $(".product-form__input .select select").on("change", "", function (e) {
        $(".deliver_text").show(),
          $(".product .hours-card-badge").show(),
          0 >= $('.product-form__input .select select option[value="' + $(this).val() + '"]').data("qty") && ($(".deliver_text").hide(), $(".product .hours-card-badge").hide());
      }),
      $(document).on("click", ".quick-add__submit", function (e) {
        e.preventDefault();
        const $button = $(this);
        const $form = $button.closest('form');
        const formData = $form.serialize();
        $button.find('.add_cart').text('Adding...');
        $button.css({ "background": "#222222" });
        $button.find('.add_cart').css({ "color": "#fff" });
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: formData,
          dataType: 'json',
          success: function (data) {
            $button.find('.add_cart').text('Added');
            $button.css({ "background": "#222222" });
            $button.find('.add_cart').css({ "color": "#fff" });
            $button.prop('disabled', true);
            $button.addClass('disabled');
            setTimeout(function () {
              if ($("quick-add-modal product-info .price").hasClass("price--sold-out")) {
                $("quick-add-modal .deliver_text").hide();
                $("quick-add-modal .hours-card-badge").hide();
              } else {
                $("quick-add-modal .deliver_text").show();
                $("quick-add-modal .hours-card-badge").show();
              }
              if ($('quick-add-modal .select select option[selected="selected"]').data("qty") <= 0) {
                $("quick-add-modal .deliver_text").hide();
                $("quick-add-modal .hours-card-badge").hide();
              } else {
                $("quick-add-modal .deliver_text").show();
                $("quick-add-modal .hours-card-badge").show();
              }
            }, 1000);
            setTimeout(function () {
              if ($("quick-add-modal product-info .price").hasClass("price--sold-out")) {
                $("quick-add-modal .deliver_text").hide();
                $("quick-add-modal .hours-card-badge").hide();
              } else {
                $("quick-add-modal .deliver_text").show();
                $("quick-add-modal .hours-card-badge").show();
              }
              if ($('quick-add-modal .select select option[selected="selected"]').data("qty") <= 0) {
                $("quick-add-modal .deliver_text").hide();
                $("quick-add-modal .hours-card-badge").hide();
              } else {
                $("quick-add-modal .deliver_text").show();
                $("quick-add-modal .hours-card-badge").show();
              }
            }, 1500);
          },
          error: function (error) {
            console.error('Error:', error);
          }
        });
      });
    $(document).on("click", ".select-size-btn", function () {
      $(this).toggleClass('active')
      // $(this).find('.select_size').hide();
      // $(this).find('.size').show();                
      $(this).removeAttr("style"), $("body").toggleClass("size_variant_open");
      var e = window.innerHeight;
      $("body").css("top", "-" + e + "px"), $(".size-variant-grid").removeClass("v_height");
      var i = $("ul.size_tab li.active").attr("rel");
      $(".size_radio_block").each(function () {
        $(this).attr("data-id"), "tab-eu" == i ? $('.size_radio_block[data-id="' + i + '"]').show() : ($(".size_radio_block").show(), $(".size_radio_block[data-id=tab-eu]").hide());
      }),
        $(".see-all-sizes").hide();

    }),
      $(document).on("click", "ul.size_tab li", function () {
        $('body').removeClass('adjust-wishlist');
        $('.with_vari.product-form__submit').css('display', 'flex');
        $(".size-variant-grid").removeClass("v_height"), $(".size-variant-grid").hasClass("vactive"), $(".size-variant-grid").removeClass("vactive");
        var e = $(this).attr("rel");
        $("ul.size_tab li").removeClass("active"),
          $(this).addClass("active"),
          $(".size_radio_block").hide(),
          $(".size_radio_block").each(function () {
            $(this).attr("data-id"), "tab-eu" == e ? $('.size_radio_block[data-id="' + e + '"]').show() : ($(".size_radio_block").show(), $(".size_radio_block[data-id=tab-eu]").hide());
          }),
          $(".see-all-sizes").hide(),
          $(".size_select_block").hide(),
          $(".size_select_block").find('.size_delivery_radio_block ').removeClass('est_active'),
          $(".size_radio_block,.size_radio_block1").removeClass("active"),
          $(".size-variant-grid").hasClass("vactive");
        var i = $(this).attr("rel");
        console.log(i),
          $(".size-variant-grid .size_radio_block").removeClass("s-opacity"),
          $(".size_radio_block").each(function () {
            var e = $(this).attr("data-id");
            console.log(e), i == e ? $(this).addClass("aactive") : $(this).removeClass("s-opacity");
          });
        var $productFormSubmit = $('body').find('.product-form__submit');
        if ($(this).hasClass('active')) {
          $productFormSubmit.addClass('tab-checked').removeClass('input-checked');
        }
        $('.wishlist-engine-button').removeClass('label_wish');
        // if ($(this).parent().hasClass("s-opacity")) {
        //     $productFormSubmit.addClass('input-checked').removeClass('input-unchecked');
        // } else {
        //     $productFormSubmit.removeClass('input-checked').addClass('input-unchecked');
        // }
      }),
      $(document).on("change", ".size_radio_block input", function () {

        $('.size_select_block  .size_delivery_radio_block ').removeClass('size_not_av');
        $('.product__info-container').find('.price').removeClass('price--on-sale');
        $('.with_vari.product-form__submit').css('display', 'none');
        $('.wishlist-engine-button').addClass('label_wish');
        $('.size_variant_popup .selected_variant').css('display', 'none');
        $('.size_variant_popup').removeClass('error_mess');
        $(".size_radio_block input").prop("checked", !1), $(this).prop("checked", !0);
        var e = $(this).attr("data-varid");
        $(".product-variant-id").val(e),
          $(".size-variant-grid").removeClass("vactive-large"),
          $(this).parent().hasClass("active")
            ? ($(".size_radio_block").removeClass("s-opacity active"),
              $(".size_select_block").hide(),
              $(".size_select_block").find('.size_delivery_radio_block ').removeClass('est_active'),
              $(".size_radio_block input").prop("checked", !1),
              $(".size-variant-grid").removeClass("vactive"),
              ("none" == $(".see-all-sizes").css("display") || "hidden" == $(".see-all-sizes").css("visibility")) && $(".size-variant-grid").addClass("v_height"),
              $(".see-all-sizes,.size_botton_text").addClass("siz_text"),
              $('.with_vari.product-form__submit').css('display', 'flex'))
            : ($(".size-variant-grid").addClass("vactive"),
              $(".size_radio_block").removeClass("active"),
              $(this).parent().addClass("active"),
              $(".size_radio_block").addClass("s-opacity"),
              $(".size_select_block").show(),
              $(".size_select_block").find('.size_delivery_radio_block ').removeClass('est_active'),
              $(".see-all-sizes,.size_botton_text").hide(),
              $(".see-all-sizes,.size_botton_text").removeClass("siz_text"),
              $(".select_v_price").text($(this).data("price")),
              $(".variant-price-point").text($(this).data("price-val")),
              $(".product__info-wrapper .price__regular .price-item--regular").text($(this).data("price")),
              $(".product__info-wrapper .price__regular .price-item-cprice").text($(this).data("cprice")),
              $(this).parent().find("span").hasClass("popup-varavsold")
                ? ($(".size_select_block").hide(), $(".size_select_block.size_unaval_select_block").show(), $(".size_select_block").find('.size_delivery_radio_block').removeClass("est_active"), $(".size_select_block.size_unaval_select_block").find('.size_delivery_radio_block').addClass("est_active"))
                : ($(".size_select_block").show(), $(".size_select_block.size_unaval_select_block").hide(), $(".size_select_block").find('.size_delivery_radio_block').addClass("est_active"), $(".size_select_block.size_unaval_select_block").find('.size_delivery_radio_block').removeClass("est_active"))),
          $(".size_delivery_radio_block input").prop("checked", !1),
          0 != $(".size_delivery_radio_block input:checked").length && $(".see-all-sizes").hide() && $(this).parents(".size-variant-grid").addClass("vactive"),
          0 == $(".size_delivery_radio_block input:checked").length &&
          ($(".size_tab").find("li.active").attr("rel"), $(".see-all-sizes").hasClass("siz_text") && $(this).parents(".size-variant-grid").removeClass("vactive vactive-large"));
        if ($(this).hasClass('inp_notav')) {
          $('.size_unaval_select_block .size_delivery_radio_block ').addClass('size_not_av');
          $('.size_variant_popup').addClass('block_variant_unavailable');
          $('product-form .product-form__submit.button').addClass('disable_btn');
          $('product-form .sizep-btn').hide();
          $('product-form .product-form__submit.button span').text('Sold out');
          $('product-form .product-form__submit.button').attr('disabled', 'disabled');
          $('body').removeClass('adjust-wishlist');
          $('.size_delivery_radio_block.est_active').hide();
          $('.sold_text_hide').show();

        } else {
          $('.size_unaval_select_block .size_delivery_radio_block ').removeClass('size_not_av');
          $('.size_variant_popup').removeClass('block_variant_unavailable');
          $('product-form .product-form__submit.button').removeClass('disable_btn');
          $('product-form .sizep-btn').css('display', 'flex');
          $('product-form .product-form__submit.button span').text('Add to cart');
          $('product-form .product-form__submit.button').removeAttr('disabled', 'disabled');
          $('body').addClass('adjust-wishlist');
          $('.size_delivery_radio_block.est_active').show();
          $('.sold_text_hide').hide();
        }
        var size = $(this).data('value');
        $('.select-size-btn').find('.active_size').text(size);
        $('.select-size-btn').find('.select_size').hide();
        $('.select-size-btn').find('.size').show();
        var $productFormSubmit = $('body').find('.product-form__submit');

        if ($(this).parent().hasClass("s-opacity")) {
          $productFormSubmit.addClass('input-checked').removeClass('input-unchecked');
        } else {
          $productFormSubmit.removeClass('input-checked').addClass('input-unchecked');
        }
      }),
      $(document).on("change", ".size_radio_block1 input", function () {
        // debugger;
        $('.qauntity_check_acv').hide();
        $('.product-form__submit.default_btn').hide();
        $('.size_select_block  .size_delivery_radio_block ').removeClass('size_not_av');
        $('.with_vari.product-form__submit').css('display', 'none');
        $('.size_variant_popup .selected_variant').css('display', 'none');
        $('.size_variant_popup').removeClass('error_mess');
        $(".size_radio_block1 input").prop("checked", !1), $(this).prop("checked", !0);
        var e = $(this).attr("data-varid");
        console.log(e),
          $(".product-variant-id").val(e),
          $(".size-variant-grid").removeClass("vactive-large"),
          $(this).parent().hasClass("active")
            ? ($(".size_radio_block1").removeClass("s-opacity active"), $(".size_radio_block1 input").prop("checked", !1), $(".size-variant-grid").removeClass("vactive"), $(".size_select_block1.show_text").show(), $(".size_select_block1.size_unaval_select_block").hide(), $(".size_select_block1.show_text .sizep-btn").hide(), $('.product-form__submit.default_btn').show(),
              $('.with_vari.product-form__submit').css('display', 'flex'))
            : ($(".size-variant-grid").addClass("vactive"),
              $(".size_radio_block1").removeClass("active"),
              $(this).parent().addClass("active"),
              $(".size_radio_block1").addClass("s-opacity"),
              $(".size_select_block1").show(),
              $(".select_v_price").text($(this).data("price")),
              $(".variant-price-point").text($(this).data("price-val")),
              $(".product__info-wrapper .price__regular .price-item--regular").text($(this).data("price")),
              $(this).parent().find("span").hasClass("popup-varavsold")
                // ? ($(".size_select_block1").hide(), $(".size_select_block1.size_unaval_select_block").show())
                // : ($(".size_select_block1").show(), $(".size_select_block1.size_unaval_select_block").hide())),
                ? ($(".size_select_block1").hide(), $(".size_select_block1.size_unaval_select_block").show(), $(".size_select_block1.show_text").hide(), $('.product-form__submit.default_btn').hide(), $(".size_select_block1").find('.size_delivery_radio_block').removeClass("est_active"), $(".size_select_block1.size_unaval_select_block").find('.size_delivery_radio_block').addClass("est_active"))
                : ($(".size_select_block1").show(), $(".size_select_block1.show_text").hide(), $(".size_select_block1.size_unaval_select_block").show(), $('.product-form__submit.default_btn').hide(), $(".size_select_block1").find('.size_delivery_radio_block').addClass("est_active"), $(".size_select_block1.size_unaval_select_block").find('.size_delivery_radio_block').removeClass("est_active"))),



          $(".size_delivery_radio_block input").prop("checked", !1);
        $('.show_text').find('.product-form__error-message-wrapper').hide();
        //  $(this).parents('.size_variant_popup').find('.size_unaval_select_block').find('.product-form__error-message-wrapper').show();  
        // var sold_text_hide = $('.sold_text_hide').text();
        // var sold_var_name = $(this).attr('value');
        // $('.size_unaval_select_block').find('.product-form__error-message-wrapper').find('.sold_var').html(sold_var_name);              
        // $('.size_unaval_select_block').find('.product-form__error-message-wrapper').html(sold_text_hide);
        $('.sold_text_hide').show();

        // 02/10
        if ($(this).hasClass('inp_notav')) {
          $('.size_unaval_select_block .size_delivery_radio_block ').addClass('size_not_av');
          $('product-form .product-form__submit.button').addClass('disable_btn');
          $('product-form .sizep-btn').hide();
          $('product-form .product-form__submit.button span').text('Sold out');
          $('product-form .product-form__submit.button').attr('disabled', 'disabled');
          $('body').removeClass('adjust-wishlist');
          $('.size_delivery_radio_block').hide();
          $('.sold_text_hide').show();
        } else {
          $('.size_unaval_select_block .size_delivery_radio_block ').removeClass('size_not_av');
          $('product-form .product-form__submit.button').removeClass('disable_btn');
          if (!($('product-form .product-form__submit.button').hasClass('disable_btn'))) {
            $('.size_select_block1.size_unaval_select_block').show();
            $('product-form .sizep-btn').css('display', 'flex');
          }
          // $('product-form .sizep-btn').css('display','flex');
          // $(".size_select_block1.show_text").hide();
          //   $('.product-form__submit.default_btn').hide();
          //   $('.size_select_block1.size_unaval_select_block').show();
          $('product-form .product-form__submit.button span').text('Add to cart');
          $('product-form .product-form__submit.button').removeAttr('disabled', 'disabled');
          $('body').addClass('adjust-wishlist');
          $('.size_delivery_radio_block').show();
          $('.sold_text_hide').hide();
          if (!($('.size_radio_block1').hasClass('active'))) {
            $('.product-form__submit.default_btn').show();
            $(".size_select_block1.show_text").hide();
            $('.size_select_block1.size_unaval_select_block').hide();
            ('product-form .sizep-btn').css('display', 'flex');
          }
        }

      }),

      $(document).on("change", ".size_radio_block.active input", function () {
        $('body').removeClass('adjust-wishlist');
      });
    $(document).on("change", ".size_radio_block1.active input", function () {
      $('body').removeClass('adjust-wishlist');
      $('.sold_text_hide').css('display', 'none');
      $('.size_delivery_radio_block').hide();
    });

    $('.product.bottom_product .size_radio_block1 ').click(function () { $(this).toggleClass('activ').siblings().removeClass('activ'); });
    //    $('.templete-cart .product.bottom_product .size_radio_block1 ').click(function(){$(this).addClass('activ').siblings().removeClass('activ');});

    $(document).on("click", ".sizingguide-btn", function (e) {
      $(".size_variant_data").hide(), $(".new_size_guide").show();
    }),
      $(document).on("click", ".guide_back", function (e) {
        $(".size_variant_data").show(), $(".new_size_guide").hide();
      }),
      $(document).on("click", ".new_size_popup_close", function () {
        $(".new_size_popup").removeClass("is-visible"), $("body").removeClass("new_size_popup_open");
      }),
      $(document).on("click", ".select-size-close", function () {
        $("body").removeClass("size_variant_open");
      }),
      $(document).on("click", ".see-all-sizes", function () {
        $(this).hide(), $(this).addClass("siz_text"), $(".size_radio_block").hide();
        var e = $("ul.size_tab li.active").attr("rel");
        $('.size_radio_block[data-id="' + e + '"]').show(), $(".size-variant-grid").addClass("vactive"), $(".size-variant-grid").addClass("vactive-large");
      }),
      $(document).on("click", ".cart__checkout-button", function (e) {
        e.preventDefault();
        const $button = $(this);
        const $form = $button.closest('form');
        // Disable the button immediately upon click
        $button.prop('disabled', true);
        $button.addClass('disabled');
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: $form.serialize(),
          dataType: 'json',
          success: function (data) {
            window.location.href = '/checkout';
          },
          error: function (error) {
            console.error('Error:', error);
            // Re-enable the button if there's an error
            $button.prop('disabled', false);
            $button.removeClass('disabled');
          }
        });
      });
    var n = "15-28 days";
    $(".not48hrs").val(n), $(".dynamic-date").text(n);
    var so = new Date(),
      ao = new Date(so);
    ao.setDate(ao.getDate() + 1);
    for (var to = 0; to < 2; to++) {
      var oo = new Date(ao);
      oo.setDate(oo.getDate() + to);
      var d1 = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
        ro = oo.getDate() + "/" + d1[oo.getMonth()];
      ro1 = so.getDate() + "/" + d1[oo.getMonth()];
      if (0 == to) var lo = ro;
    }
    var no = ro1 + " - " + lo;
    $(".blue_btn").text(no);
  }),
  $(window).on("load", function () {
    $("body").removeClass("oveflow");
  }),
  $(document).on("click", ".size_select_block  .close_icon", function () {
    $(this).parents(".size_variant_popup").find(".size-variant-grid").removeClass("vactive"),
      $(this).parents(".size_variant_popup").find(".size-variant-grid").addClass("v_height"),
      $('.with_vari.product-form__submit').css('display', 'flex'),
      $(this).parents(".size_variant_popup").find(".size_select_block ").css("display", "none"),
      $(this)
        .parents(".size_variant_popup")
        .find(".size_radio_block ")
        .each(function () {
          $(this).removeClass("active s-opacity");
        });
  }),
  $(document).ready(function () {

    $(".product-form__submit.select-size-btn").on("click", function () {
      $(".stamped-launcher-button").css("visibility", "hidden"), $("#dummy-chat-button-iframe").css("visibility", "hidden"), $("#dummy-chat-button-iframe , .stamped-launcher-button").css("display", "none");
    }),
      $(".size-popup-botton .select-size-close").on("click", function () {
        $(".stamped-launcher-button").css("visibility", "visible"), $("#dummy-chat-button-iframe").css("visibility", "visible"), $("#dummy-chat-button-iframe , .stamped-launcher-button").css("display", "block");
      }),
      $(".service-payment-hp ul").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 100,
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: 3 } },
          { breakpoint: 1025, settings: { slidesToShow: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1 } },
        ],
      });
    $(".product-form .product-form__submit").click(function () {
      $('.show_text').find('.product-form__error-message-wrapper').html('<span><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" class="styles_Icon__kgN2b styles_alertIcon__q13Rr styles_theme-negative__KXEsj"><path stroke="#e70020" stroke-linecap="round" stroke-linejoin="round" d="M10 18.333a8.333 8.333 0 100-16.666 8.333 8.333 0 000 16.666zm0-11.666V10m0 3.333h.008"></path></svg> To continue, select the desired size</span>')
      var sold_text_hide = $('.sold_text_hide').text();
      $('.size_unaval_select_block').find('.product-form__error-message-wrapper').html(sold_text_hide);
      $('.basket_popup').show();
      $('body').addClass('basket_body');
    });

    // $('.with_vari.product-form__submit').on('click' , function(){   
    // $(this).parents('.size_variant_popup').find('.selected_variant').css('display' , 'flex');
    // $('.size_variant_popup').addClass('error_mess');
    // });  

    $('.size_select_block1.show_text').on('click', function () {
      // debugger;   
      $(this).parents('.size_variant_popup').find('.selected_variant').css('display', 'flex');
      $('.size_variant_popup').addClass('error_mess');
    })

    $('.size_unaval_select_block .sizep-btn , .size_select_block  .sizep-btn').on('click', function () {

      $('.qauntity_check_acv').css('display', 'none');
      var quan_avil = $(this).parents('.size_variant_data').find('.size-variant-grid .active').attr('data-variant_quantity');
      if (quan_avil) {
        var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
          .then(response => response.json())
          .then(data => {
            var variant_id = parseInt($(this).parents('.size_variant_data').find('.size-variant-grid .active').attr('data-variant_id'));
            var variant_qty = parseInt($(this).parents('.size_variant_data').find('.size-variant-grid .active').attr('data-variant_quantity'));
            for (i = 0; i < data.items.length; i++) {
              var cart_varinat_id = parseInt(data.items[i].variant_id);
              var cart_varinat_qty = parseInt(data.items[i].quantity);
              if (cart_varinat_id === variant_id) {
                if (variant_qty === cart_varinat_qty) {
                  $('.qauntity_check_acv').css('display', 'flex');
                }
              }
            }
          });
      }

      if ($('.recipient-form').find('input[type="checkbox"]').is(":checked") == true) {
        var emailValue = $('.field__input.recipient_email').val().trim();
        var $emailField = $('.recipient-fields__field');
        if (emailValue.length === 0) {
          $('#email-error-msg').removeClass('hidden');
          $emailField.addClass('has-error');
        }
      }


      var varId = $(this).parents('.product-form').find('.product-variant-id').val();
      var $form = $(this).parents('.product-form').find('form');
      var formData = $form.serialize();
      $.ajax({
        type: 'POST',
        async: false,
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function () {
          fetchAndReplaceHtml('CartDrawer-CartItems');
          $("body").removeClass("size_variant_open");
          $('.latest-item .title').html($('.product__title h1').html());
          var size = $('.size_radio_block.active').find('.size_input').data('value');
          var price = $('.size_radio_block.active').find('.size_input').data('price');
          var pricePoints = $('.size_radio_block.active').find('.size_input').data('price-val');
          var size1 = $('.size_radio_block1.active').find('input').data('value');
          var price1 = $('.size_radio_block1.active').find('input').data('price');
          $('.latest-item .price').html(size + '- ' + price);
          $('.latest-item1 .price').html(size1 + '- ' + price1);
          $('.latest-points').html(pricePoints);
          $('.latest-pro-remove').attr('data-var-id', varId);
          setTimeout(function () {
            $('.basket_popup').show();
            $('body').addClass('basket_body');
            var esttime = $('.size_delivery_radio_block.est_active').html();
            $('.bas_est_time').empty();
            $('.bas_est_time').html(esttime);
            if ($(window).width() <= 767) {
              $('body').removeClass('is-empty');
              $('#tab4').load(location.href + " #tab4 > *", "");
              $("#mobile-count").load(location.href + " #mobile-count > *", "");
            }
          }, 500);


        },
        error: function () {
          console.log('Error adding items to cart');
        }
      });
      // $('.product_size_fixed').hide();
    });
    $('.latest-pro-remove,.popup_overlay').on('click', function () {
      $('.basket_popup').hide();
      $('body').removeClass('basket_body');
      $('.bas_est_time').empty();
      // $('.product_size_fixed').show(); 
    });
    $('size-cart-popup-remove').on('click', function () {
      $('.size-popup-cart').hide();
      $('body').removeClass('size_variant_open');
    });
    $('.size_variant_ovrlay').on('click', function () {
      $('.size_variant_popup').hide();
      $('body').removeClass('size_variant_open');
    });
    $(document).on("click", ".bas_select", function (e) {
      $(this).hide();
      $(this).parents('.slider-slick-class').find('.product-form__input').show();
      $(this).parents('.slider-slick-class').find('.quick-add__submit').show();
    });
    $('.main-slider-parent-clean .select__select').on('change', function () {
      var val = $(this).val();
      $(this).parents('.slider-slick-class').find('.single-clean-addtocart').find('[name="id"]').val(val);
    });
    // 25/09  
    $('.with_vari.product-form__submit').on('click', function () {
      $(this).parents('.size_variant_popup').find('.selected_variant').css('display', 'flex');
      $('.size_variant_popup').addClass('error_mess');
    });
    $(".custom-shipping-mobile-slider").slick({
      slidesToShow: 3, slidesToScroll: 1, variableWidth: true, infinite: true, autoplay: true, autoplaySpeed: 0, speed: 26000, pauseOnHover: false, arrows: false, cssEase: 'linear',
      responsive: [{
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      ]
    });
  });
$(window).on("load", function () {
  $(".marquee_sli").removeClass("oveflow_hidd");
});
function fetchAndReplaceHtml(e) {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((e) => e.text())
    .then((e) => {
      let t = new DOMParser().parseFromString(e, "text/html");
      for (let r of ["cart-drawer-items", ".cart-drawer__footer", ".drawer__header", ".top-cart-header"]) {
        let a = document.querySelector(r),
          i = t.querySelector(r);
        a && i && (a.replaceWith(i), $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*", ""));
      }
    })
    .catch((e) => {
      console.error(e);
    }),
    $(".drawer__inner-empty").hide(),
    setTimeout(function () {
      $("cart-drawer").removeClass("is-empty"),
        $(".drawer__inner-empty").hide(),
        $("#CartDrawer-Checkout").removeAttr("disabled"),
        $("a#cart-icon-bubble").load(location.href + " a#cart-icon-bubble>*", "");
    }, 100);
}
$(document).ready(function () {

  if ($(window).width() <= 767) {
    var $footer = $('.newsletter');
    function checkVisibility() {
      var windowBottom = $(window).scrollTop() + $(window).height();
      var footerTop = $footer.offset().top + 85;

      if (windowBottom >= footerTop) {
        $('body').addClass('visible-in-viewport');
        $('.newsletter-product-fixed').css('opacity', 1);
      } else {
        $('body').removeClass('visible-in-viewport');
        $('.newsletter-product-fixed').css('opacity', 0);
      }
    }
    $(window).on('scroll load', checkVisibility);
  }
  $(document).scroll(function () {

    if ($(".product_size_fixed").length > 0) {
      var w = $(window);
      var offset = $(".product__info-wrapper .product-form__submit.select-size-btn").offset();
      console.log(offset);
      var btnheight = parseFloat(offset.top - w.scrollTop());
      if (btnheight <= 40) {
        $('.product_size_fixed').fadeIn();
        $('.product_size_fixed').addClass('active');
      }
      else {
        $('.product_size_fixed').fadeOut();
        $('.product_size_fixed').removeClass('active');
      }
    }
  });
  var toTop = $('.product_size_fixed , .newsletter-product-fixed');
  var h1 = $(".product-form__submit.select-size-btn").offset();
  toTop.on('click', function () {
    $('html, body').animate({
      scrollTop: h1.top - 125
    });
    $(".product-form__submit.select-size-btn").trigger("click");
    return false;
  });
  $('.wishlist-engine').on('click', function () {
    $(this).addClass('label_wish');
  });
  $('.mobile-header .header__icon--menu').on('click', function () {
    $('body').toggleClass('mobile-menu-toggle');
  });
  // 09-07
  const navItems = document.querySelectorAll('.vertical_menu_data .nav-item');
  if (navItems.length > 0) {
    navItems.forEach(item => {
      item.addEventListener('click', function () {
        console.log('Clicked Item:', this);
        navItems.forEach(nav => nav.classList.remove('active'));
        this.classList.add('active');
      });
    });
  }
  $('.account_left .my_profile').click(function () {
    $('.account_left .vertical_menu_data').toggleClass('open');
    $('body').toggleClass('open_drawer');
  });
  $('.account_left .close-menu').click(function () {
    $('.account_left .vertical_menu_data').removeClass('open');
    $('body').removeClass('open_drawer');
  });
  $('.announcement-bar .close').click(function () {
    $('body').addClass('announcement-closed');
  });
  $(document).on("change", "#cart-drawer-check", function () {
    $(this).is(":checked") ? ($("#CartDrawer-Checkout").removeAttr("disabled", ""),
      $("#checkout").removeAttr("disabled", "")) : ($("#CartDrawer-Checkout").attr("disabled", ""),
        $("#checkout").attr("disabled", ""));
  });
  $(document).on("click", "#main-cart-wrap .toggle-container cart-remove-button", function () {
    setTimeout(function () {
      location.reload();
    }, 800);
  });

  $('.account_left .vertical_menu_data .nav-item').click(function (event) {
    event.stopPropagation();
    $('.account_left .vertical_menu_data').removeClass('open');
    $('body').removeClass('open_drawer');
  });
});

$(document).ready(function () {
  $(document).on("click", ".cart__items .select-size-btn", function () {
    var cartItem = $(this).closest('.cart-productCard');
    $('.size-popup-cart, .size_variant_popup').not(cartItem.find('.size-popup-cart, .size_variant_popup')).hide();

    cartItem.find('.size-popup-cart').show();
    cartItem.find('.size_variant_popup').show();

    $('body').addClass('size_variant_cart_open size_variant_open');
  });
  $('.custom--cart .size-cart-popup-remove').on('click', function () {
    $('.size_variant_popup').hide();
    $('body').removeClass('size_variant_open');
    location.reload();
  });
  $(document).on("change", ".cart__items .size_radio_block1 input", function () {
    if ($(this).hasClass('inp_notav')) {
      $(".sold_text_hide").css("display", "block");
      $(".sold-out-btn").css("display", "flex");
      $(".primary-action").css("display", "none");
    } else {
      $(".sold_text_hide").css("display", "none");
      $(".sold-out-btn").css("display", "none");
      $(".primary-action").css("display", "flex");
    }
  });
  $(document).on("change", ".cart__items .size_radio_block input", function () {
    if ($(this).hasClass('inp_notav')) {
      $(".sold_text_hide").css("display", "block");
      $(".sold-out-btn").css("display", "flex");
      $(".primary-action").css("display", "none");
    } else {
      $(".sold_text_hide").css("display", "none");
      $(".sold-out-btn").css("display", "none");
      $(".primary-action").css("display", "flex");
    }
  });
  $(document).on('click', '.templete-cart .size-variant__actions .button', function () {
    var cartItem = $(this).closest('.cart-productCard');
    var $checkedSizeInput = cartItem.find('.size_input:checked');
    var mainprodid = $(this).parents(".cart-productCard").attr("data-item-index");
    var quantityprod = $(this).parents(".cart-productCard").find("quantity-input input").val();
    if ($checkedSizeInput.length) {
      var varId = $checkedSizeInput.data('varid');
      var selectedValue = $checkedSizeInput.val();
      //   alert('Selected value: ' + selectedValue);
      $.ajax({
        url: "/cart/change.js",
        type: "post",
        dataType: 'json',
        data: { quantity: 0, line: mainprodid },
        success: function (cart) {
          $.ajax({
            url: "/cart/add.js",
            type: "post",
            dataType: 'json',
            async: false,
            data: { quantity: quantityprod, id: varId },
            success: function (cart) {
              location.reload();
            },
            error: function (err) {
            }
          });
        },
        error: function (err) {
        }
      });
    } else {
      alert('No size input is checked.');
    }
  });
  $(document).on("change", " .custom--cart .size_radio_block input", function () {

  });
  $(document).on("click", ".featured-coll-popup-btn", function () {
    var cartItem = $(this).closest('.grid__item.slick-slide');
    $('.featured-size-popup-cart .size-popup-cart,.featured-size-popup-cart .size_variant_popup').not(cartItem.find('.featured-size-popup-cart .size-popup-cart,.featured-size-popup-cart .size_variant_popup')).hide();
    cartItem.find('.featured-size-popup-cart .size-popup-cart').show();
    cartItem.find('.featured-size-popup-cart .size_variant_popup').show();
    var popup = cartItem.find('.featured-size-popup-cart').detach().appendTo('.cart-featured-popup');
    popup.show();
    $('body').addClass('feat_size_variant_cart_open feat_size_variant_open');
  });
  $('.size-cart-popup-remove').on('click', function () {
    $('.featured-size-popup-cart').hide();
    $('.featured-size-popup-cart .size_variant_popup').hide();
    $('body').removeClass('feat_size_variant_open');
    $('body').removeClass('feat_size_variant_cart_open');
    var popupContainer = $(this).closest('.cart-featured-popup');
    popupContainer.empty();
  });
  $(document).on('click', '.featured-size-popup-cart', function (event) {
    event.stopPropagation();
  });
  $(document).on('click', '.featured-coll-popup-btn', function (event) {
    event.stopPropagation();
  });
  $(document).on("click", ".templete-cart .featured-coll-popup-btn.product-form__submit", function (e) {
    e.preventDefault();
    $('.sizep-btn').on('click', function () {
      var varId = $(this).parents('.product-form').find('.product-variant-id').val();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { quantity: 1, id: varId },
        dataType: 'json',
        success: function () {
          $('.fea-coll-popup').hide();
          $("body").removeClass("feat_size_variant_cart_open");
          $("body").removeClass("feat_size_variant_open");
          location.reload();
        },
        error: function () {
          console.log('Error adding items to cart');
        }
      });
    });
  });

  // $('.mobile-header .header__icon--account').on('click', function () {
  //    $('body').addClass('open_drawer');
  //   sessionStorage.setItem('addClass', 'true');
  //   window.location.href ='/account';
  // });
  // $('#customer_login button').on('click', function () {
  //    $('body').addClass('open_drawer');
  //   sessionStorage.setItem('addClass', 'true');
  //   window.location.href ='/account';
  // });
  // if (sessionStorage.getItem('addClass') === 'true') {
  //   $('body').addClass('open_drawer');
  //   $('body').find('.vertical_menu_data').addClass('open');
  //   sessionStorage.removeItem('addClass');
  // }
});
// 10-08-24 Nidhi
$(document).ready(function () {
  // Selecting the input element and setting up the event listener
  $('#gift_recipet_data').attr('value', '');
  $('.field__input.recipient_email').on('input', function () {
    var recipient_email = $(this).val();  // Using jQuery to get the value of the input
    console.log(recipient_email);  // Logging the email to the console
    // debugger;
    $('.gift_recipet_data').attr('value', recipient_email);
  });

});

